/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NodataDiscardAdditionalServiceItem } from './NodataDiscardAdditionalServiceItem';
import {
    NodataDiscardAdditionalServiceItemFromJSON,
    NodataDiscardAdditionalServiceItemFromJSONTyped,
    NodataDiscardAdditionalServiceItemToJSON,
    NodataDiscardAdditionalServiceItemToJSONTyped,
} from './NodataDiscardAdditionalServiceItem';

/**
 * 
 * @export
 * @interface NodataDiscardReqVo
 */
export interface NodataDiscardReqVo {
    /**
     * 无数据记录ID
     * @type {number}
     * @memberof NodataDiscardReqVo
     */
    id: number;
    /**
     * 货物收费总金额，韩国废弃默认 0
     * @type {number}
     * @memberof NodataDiscardReqVo
     */
    totalGoodsAmount?: number;
    /**
     * 附加服务总金额（韩国废弃必填）
     * @type {number}
     * @memberof NodataDiscardReqVo
     */
    totalAdditionalServiceAmount?: number;
    /**
     * 账单总金额（韩国废弃必填）
     * @type {number}
     * @memberof NodataDiscardReqVo
     */
    totalAmount?: number;
    /**
     * 货币代码，韩国默认 KRW
     * @type {string}
     * @memberof NodataDiscardReqVo
     */
    currencyCode?: string;
    /**
     * 用户ID；未登记时可传，否则取无数据已绑定用户
     * @type {number}
     * @memberof NodataDiscardReqVo
     */
    userId?: number;
    /**
     * 账单状态，韩国默认 0-未支付
     * @type {number}
     * @memberof NodataDiscardReqVo
     */
    status?: number;
    /**
     * 是否发送短信：1-发送，0-不发送，默认 0
     * @type {number}
     * @memberof NodataDiscardReqVo
     */
    sendSms?: number;
    /**
     * 附加服务明细（韩国废弃必填，前端组装）
     * @type {Array<NodataDiscardAdditionalServiceItem>}
     * @memberof NodataDiscardReqVo
     */
    additionalServiceList?: Array<NodataDiscardAdditionalServiceItem>;
}

/**
 * Check if a given object implements the NodataDiscardReqVo interface.
 */
export function instanceOfNodataDiscardReqVo(value: object): value is NodataDiscardReqVo {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function NodataDiscardReqVoFromJSON(json: any): NodataDiscardReqVo {
    return NodataDiscardReqVoFromJSONTyped(json, false);
}

export function NodataDiscardReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NodataDiscardReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'totalGoodsAmount': json['totalGoodsAmount'] == null ? undefined : json['totalGoodsAmount'],
        'totalAdditionalServiceAmount': json['totalAdditionalServiceAmount'] == null ? undefined : json['totalAdditionalServiceAmount'],
        'totalAmount': json['totalAmount'] == null ? undefined : json['totalAmount'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'status': json['status'] == null ? undefined : json['status'],
        'sendSms': json['sendSms'] == null ? undefined : json['sendSms'],
        'additionalServiceList': json['additionalServiceList'] == null ? undefined : ((json['additionalServiceList'] as Array<any>).map(NodataDiscardAdditionalServiceItemFromJSON)),
    };
}

export function NodataDiscardReqVoToJSON(json: any): NodataDiscardReqVo {
    return NodataDiscardReqVoToJSONTyped(json, false);
}

export function NodataDiscardReqVoToJSONTyped(value?: NodataDiscardReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'totalGoodsAmount': value['totalGoodsAmount'],
        'totalAdditionalServiceAmount': value['totalAdditionalServiceAmount'],
        'totalAmount': value['totalAmount'],
        'currencyCode': value['currencyCode'],
        'userId': value['userId'],
        'status': value['status'],
        'sendSms': value['sendSms'],
        'additionalServiceList': value['additionalServiceList'] == null ? undefined : ((value['additionalServiceList'] as Array<any>).map(NodataDiscardAdditionalServiceItemToJSON)),
    };
}

